import ConfigProvider from './config-provider';
export default ConfigProvider;
